<template>
  <div class="outer-box">
    <h3>Support AI</h3>
    <div class="inner-box" style="text-align: left; max-height: 99vh !important; height: 80vh;">
      <SupportChatComponent></SupportChatComponent>
    </div>
  </div>
</template>

<script>
import SupportAIService, { SupportMessagesList } from "@/services/SupportAiService";
import store from "@/store/index";
import SupportChatComponent from "./support-ai/SupportChatComponent.vue";
import * as moment from 'moment'
export default {
  methods: {},
  components: {
    SupportChatComponent,
  },
};
</script>
